module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', {
    class: {
      'p-left': _vm.isLeft
    }
  }, [_vm._v(_vm._s(_vm.desc))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c5ced154!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/firm_intro/HomeFirmContent.vue
// module id = 170
// module chunks = 1